import {
  disableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

import {
  createFocusTrap
} from 'focus-trap';

const SELECTOR_MENU = '.js-main-menu';
const SELECTOR_TRIGGER = '.js-menu-toggle';
const CLASSNAME_OPEN = 'menu--open';

let trap;
let isOpen = false;

export const openMenu = (e) => {
  trap && trap.activate();
  isOpen = true;
}

export const closeMenu = (e) => {
  trap && trap.deactivate();
  isOpen = false;
}

const onToggleClick = (e) => {
  e.preventDefault();
  isOpen ? closeMenu() : openMenu();
}

const init = () => {
  [].forEach.call(
    document.querySelectorAll(SELECTOR_TRIGGER),
    el => el.addEventListener('click', onToggleClick)
  );

  const menu = document.querySelector(SELECTOR_MENU);

  trap = createFocusTrap(SELECTOR_MENU, {
    onActivate: () => {
      document.body.classList.add(CLASSNAME_OPEN);
      disableBodyScroll(menu);
    },
    onDeactivate: () => {
      document.body.classList.remove(CLASSNAME_OPEN);
      clearAllBodyScrollLocks();
    },
  });
}

export default {
  init,
  closeMenu
}
